import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d64b03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header align-left"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id", "innerHTML"]
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn divider" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.noticeInfos, (noticeInfo, index) => {
      return (_openBlock(), _createBlock(_Transition, {
        key: index,
        appear: "",
        name: "slide-up",
        onAfterLeave: $setup.onAfterLeave,
        persisted: ""
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              ($setup.hasText(noticeInfo.content))
                ? (_openBlock(), _createElementBlock("header", _hoisted_4, [
                    _createElementVNode("p", null, _toDisplayString(noticeInfo.title), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("section", {
                class: _normalizeClass(["zoom-control-wrapper", { 'has-text': $setup.hasText(noticeInfo.content) }])
              }, [
                _createVNode($setup["ZoomControl"], {
                  landscape: true,
                  "target-container-id": `notice-${index}`,
                  "target-content-id": `notice-content-${index}`
                }, null, 8 /* PROPS */, ["target-container-id", "target-content-id"])
              ], 2 /* CLASS */),
              _createElementVNode("section", {
                id: `notice-${index}`,
                class: _normalizeClass(["modal-body align-left", { 'has-text': $setup.hasText(noticeInfo.content) }])
              }, [
                _createElementVNode("div", {
                  id: `notice-content-${index}`,
                  innerHTML: $setup.DOMPurify.sanitize(noticeInfo.content),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.validateUrlLink && $setup.validateUrlLink(...args)))
                }, null, 8 /* PROPS */, _hoisted_6)
              ], 10 /* CLASS, PROPS */, _hoisted_5)
            ]),
            _createElementVNode("footer", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-cancel",
                type: "button",
                onClick: ($event: any) => ($setup.onClickNoMoreShowForThreeDays(noticeInfo))
              }, " 3일 동안 보지 않기 ", 8 /* PROPS */, _hoisted_8),
              _hoisted_9,
              _createElementVNode("button", {
                class: "btn btn-ok",
                type: "button",
                onClick: $setup.onClickClose
              }, " 닫기 ")
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, $setup.nowNoticeIndex === index]
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}